import React, { useEffect, useState } from 'react'
import '../assets/stylesheets/WordCount.css'

export const WordCount = (props) => {
    let { quill } = props

    const [wordCount, setWordCount] = useState(0)
    const [characters, setCharacters] = useState(0)
    const [characterWithoutSpace, setCharacterWithoutSpace] = useState(0)
    
    quill.on('text-change', function(delta, oldDelta, source) {
       if (source === 'user') {
            words()
            character()
            characterWtSpace()
        }
      });

    const words = () => {
        let text = quill.getText()
        let wordArr = text.split(' ')
        setWordCount(wordArr.length - 1)
    }

    const character = () => {
        let text = quill.getText()
        setCharacters(text.length - 1)
    }

    const characterWtSpace = () => {
        let text = quill.getText()
        let txt = text.replaceAll(' ','')
        setCharacterWithoutSpace(txt.length - 1)
    }
    
    useEffect(() => {
        words()
        character()
        characterWtSpace()
    }, [])

  return (
    <div className='word-count-div'>
          <p>Words: <span>{ wordCount }</span></p>
          <p>Characters: <span>{ characters }</span></p>
          <p>Characters excluding spaces: <span>{ characterWithoutSpace }</span></p>
    </div>
  )
}
